import {
  FingerWritingAnswer,
  FingerWritingSoundMode,
  TextOrderingAnswer,
} from '../../models/GameStore';

//
// Example usage
export const mockQuickMemoryAnswer: TextOrderingAnswer = {
  words: [
    {
      word: 'Apple has halted the rollout of the iPadOS 18 update and confirmed that there is an issue with it that needs to be fixed.',
      units: [
        {
          key: 'honorificabilitudinitatibushonorificabilitudinitatibushonorifil',
          type: 'hint',
        },
        { key: ' ', type: 'hint' },
        { key: 'Apple', type: 'hint' },
        { key: ' ', type: 'hint' },
        { key: 'has', type: 'blank' },
        { key: ' ', type: 'hint' },
        {
          key: 'honorificabilitudinitatibushonorificabilitudinitatibushonorifilhonorificabilitudinitatibushonorificabilitudinitatibushonorif',
          type: 'blank',
        },
        { key: ' ', type: 'hint' },
        { key: 'Apple', type: 'hint' },
        { key: ' ', type: 'hint' },
        { key: 'has', type: 'hint' },
        { key: ' ', type: 'hint' },
        { key: 'halted', type: 'blank' },
        { key: ' ', type: 'hint' },
        { key: 'the', type: 'hint' },
        { key: ' ', type: 'hint' },
        { key: 'rollout', type: 'blank' },
        { key: ' ', type: 'hint' },
        { key: 'of', type: 'hint' },
        { key: ' ', type: 'hint' },
        { key: 'the', type: 'hint' },
        { key: ' ', type: 'hint' },
        { key: 'iPadOS', type: 'blank' },
        { key: ' ', type: 'hint' },
        { key: '18', type: 'hint' },
        { key: ' ', type: 'hint' },
        { key: 'update', type: 'hint' },
        { key: ' ', type: 'hint' },
        { key: 'and', type: 'hint' },
        { key: ' ', type: 'hint' },
        { key: 'confirmed', type: 'blank' },
        { key: ' ', type: 'hint' },
        { key: 'that', type: 'hint' },
        { key: ' ', type: 'hint' },
        { key: 'there', type: 'hint' },
        { key: ' ', type: 'hint' },
        { key: 'is', type: 'blank' },
        { key: ' ', type: 'hint' },
        { key: 'an', type: 'hint' },
        { key: ' ', type: 'hint' },
        { key: 'issue', type: 'blank' },
        { key: ' ', type: 'hint' },
        { key: 'with', type: 'hint' },
        { key: ' ', type: 'hint' },
        { key: 'it', type: 'hint' },
        { key: ' ', type: 'hint' },
        { key: 'that', type: 'hint' },
        { key: ' ', type: 'hint' },
        { key: 'needs', type: 'hint' },
        { key: ' ', type: 'hint' },
        { key: 'to', type: 'hint' },
        { key: ' ', type: 'hint' },
        { key: 'be', type: 'hint' },
        { key: ' ', type: 'hint' },
        { key: 'fixed', type: 'hint' },
        { key: '.', type: 'hint' },
      ],
    },
    {
      word: 'However, the company also revealed that the issue is currently only limited to the M4-powered iPad Pro models.',
      units: [
        { key: 'However', type: 'blank' },
        { key: ',', type: 'hint' },
        { key: ' ', type: 'hint' },
        { key: 'the', type: 'hint' },
        { key: ' ', type: 'hint' },
        { key: 'company', type: 'blank' },
        { key: ' ', type: 'hint' },
        { key: 'also', type: 'blank' },
        { key: ' ', type: 'hint' },
        { key: 'revealed', type: 'blank' },
        { key: ' ', type: 'hint' },
        { key: 'that', type: 'hint' },
        { key: ' ', type: 'hint' },
        { key: 'the', type: 'hint' },
        { key: ' ', type: 'hint' },
        { key: 'issue', type: 'hint' },
        { key: ' ', type: 'hint' },
        { key: 'is', type: 'hint' },
        { key: ' ', type: 'hint' },
        { key: 'currently', type: 'blank' },
        { key: ' ', type: 'hint' },
        { key: 'only', type: 'blank' },
        { key: ' ', type: 'hint' },
        { key: 'limited', type: 'blank' },
        { key: ' ', type: 'hint' },
        { key: 'to', type: 'hint' },
        { key: ' ', type: 'hint' },
        { key: 'the', type: 'hint' },
        { key: ' ', type: 'hint' },
        { key: 'M4-powered', type: 'blank' },
        { key: ' ', type: 'hint' },
        { key: 'iPad', type: 'hint' },
        { key: ' ', type: 'hint' },
        { key: 'Pro', type: 'hint' },
        { key: ' ', type: 'hint' },
        { key: 'models', type: 'blank' },
        { key: '.', type: 'hint' },
      ],
    },
  ],
  soundMode: 'normal',
  locale: 'en-US',
  answerFirstLetter: true,
  isLyrics: false,
  useColor: false,
} as TextOrderingAnswer;

export const mockSpellingBySyllableAnswer: TextOrderingAnswer = {
  answerFirstLetter: false,
  soundMode: 'normal',
  locale: 'en-US',
  words: [
    {
      units: [
        {
          key: 'ho',
          distractors: 'none',
          type: 'blank',
        },
        {
          type: 'blank',
          distractors: 'none',
          key: 'no',
        },
        {
          distractors: 'none',
          key: 'ri',
          type: 'blank',
        },
        {
          key: 'fi',
          distractors: 'none',
          type: 'blank',
        },
        {
          distractors: 'none',
          key: 'ca',
          type: 'blank',
        },
        {
          type: 'blank',
          distractors: 'none',
          key: 'bi',
        },
        {
          type: 'blank',
          key: 'li',
          distractors: 'none',
        },
        {
          type: 'blank',
          distractors: 'none',
          key: 'tu',
        },
        {
          type: 'blank',
          distractors: 'none',
          key: 'di',
        },
        {
          key: 'ni',
          distractors: 'none',
          type: 'blank',
        },
        {
          key: 'ta',
          type: 'blank',
          distractors: 'none',
        },
        {
          distractors: 'none',
          key: 'ti',
          type: 'blank',
        },
        {
          key: 'bus',
          type: 'blank',
          distractors: 'none',
        },
      ],
      word: 'honorificabilitudinitatibus',
    },
  ],
  isLyrics: false,
  useColor: false,
} as TextOrderingAnswer;

export const mockSyllableAnswer: TextOrderingAnswer = {
  answerFirstLetter: false,
  soundMode: 'normal',
  locale: 'en-US',
  words: [
    {
      units: [
        {
          key: 'ho',
          distractors: 'none',
          type: 'blank',
        },
        {
          type: 'blank',
          distractors: 'none',
          key: 'no',
        },
        {
          type: 'hint',
          key: ' ',
        },
        {
          distractors: 'none',
          key: 'ri',
          type: 'hint',
        },
        {
          type: 'hint',
          key: ' ',
        },
        {
          key: 'fi',
          distractors: 'none',
          type: 'blank',
        },
        {
          distractors: 'none',
          key: 'ca',
          type: 'blank',
        },
        {
          type: 'blank',
          distractors: 'none',
          key: 'bi',
        },
        {
          type: 'hint',
          key: ' ',
        },
        {
          type: 'hint',
          key: 'li',
          distractors: 'none',
        },
        {
          type: 'hint',
          key: ' ',
        },
        {
          type: 'blank',
          distractors: 'none',
          key: 'tu',
        },
        {
          type: 'hint',
          key: ' ',
        },
        {
          type: 'hint',
          distractors: 'none',
          key: 'di',
        },
        {
          type: 'hint',
          distractors: 'none',
          key: '你',
        },
        {
          type: 'hint',
          key: ' ',
        },
        {
          key: 'ni',
          distractors: 'none',
          type: 'blank',
        },
        {
          key: 'ta',
          type: 'blank',
          distractors: 'none',
        },
        {
          distractors: 'none',
          key: 'ti',
          type: 'blank',
        },
        {
          key: 'bus',
          type: 'blank',
          distractors: 'none',
        },
      ],
      word: 'honorificabilitudinitatibus',
    },
  ],
  isLyrics: false,
  useColor: false,
} as TextOrderingAnswer;

export const mockSpellingByCharAnswer: TextOrderingAnswer = {
  locale: 'en-US',
  answerFirstLetter: false,
  soundMode: 'normal',
  words: [
    {
      word: 'honorificabilitudinitatibus',
      units: [
        {
          type: 'hint',
          key: 'h',
        },
        {
          type: 'hint',
          key: 'h',
        },
        {
          type: 'hint',
          key: ' ',
        },
        {
          type: 'blank',
          key: 'h',
        },
        {
          key: 'o',
          type: 'blank',
        },
        {
          type: 'blank',
          key: 'n',
        },
        {
          type: 'blank',
          key: 'o',
        },
        {
          type: 'blank',
          key: 'r',
        },
        {
          type: 'blank',
          key: 'i',
        },
        {
          type: 'blank',
          key: 'f',
        },
        {
          type: 'blank',
          key: 'i',
        },
        {
          key: 'c',
          type: 'blank',
        },
        {
          key: 'a',
          type: 'blank',
        },
        {
          type: 'blank',
          key: 'b',
        },
        {
          key: 'i',
          type: 'blank',
        },
        {
          type: 'blank',
          key: 'l',
        },
        {
          key: 'i',
          type: 'blank',
        },
        {
          type: 'blank',
          key: 't',
        },
        {
          key: 'u',
          type: 'blank',
        },
        {
          type: 'blank',
          key: 'd',
        },
        {
          key: 'i',
          type: 'blank',
        },
        {
          type: 'blank',
          key: 'n',
        },
        {
          type: 'blank',
          key: 'i',
        },
        {
          type: 'blank',
          key: 't',
        },
        {
          type: 'blank',
          key: 'a',
        },
        {
          type: 'blank',
          key: 't',
        },
        {
          type: 'blank',
          key: 'i',
        },
        {
          type: 'blank',
          key: 'b',
        },
        {
          type: 'blank',
          key: 'u',
        },
        {
          type: 'blank',
          key: 's',
        },
        {
          type: 'hint',
          key: ' ',
        },
        {
          type: 'hint',
          key: 'h',
        },
        {
          type: 'hint',
          key: 'h',
        },
        {
          type: 'blank',
          key: 'h',
        },
        {
          type: 'blank',
          key: 'h',
        },
      ],
    },
  ],
  isLyrics: false,
  useColor: false,
} as TextOrderingAnswer;

export const mockSpellingAnswer: TextOrderingAnswer = {
  locale: 'en-US',
  answerFirstLetter: false,
  soundMode: 'normal',
  words: [
    {
      word: 'honorificabilitudinitatibus',
      units: [
        {
          type: 'blank',
          key: 'h',
        },
        {
          key: 'o',
          type: 'blank',
        },
        {
          type: 'blank',
          key: 'n',
        },
        {
          type: 'hint',
          key: ' ',
        },
        {
          type: 'hint',
          key: 'abc',
        },
        {
          type: 'hint',
          key: ' ',
        },
        {
          type: 'blank',
          key: 'r',
        },
        {
          type: 'blank',
          key: 'i',
        },
        {
          type: 'blank',
          key: 'f',
        },
        {
          type: 'blank',
          key: 'i',
        },
        {
          key: 'c',
          type: 'blank',
        },
        {
          type: 'hint',
          key: ' ',
        },
        {
          type: 'hint',
          key: 'abc',
        },
        {
          type: 'hint',
          key: ' ',
        },
        {
          key: 'a',
          type: 'blank',
        },
        {
          type: 'blank',
          key: 'b',
        },
        {
          key: 'i',
          type: 'blank',
        },
        {
          type: 'blank',
          key: 'l',
        },
        {
          key: 'i',
          type: 'blank',
        },
        {
          type: 'blank',
          key: 't',
        },
        {
          key: 'u',
          type: 'blank',
        },
        {
          type: 'blank',
          key: 'd',
        },
        {
          type: 'hint',
          key: ' ',
        },
        {
          type: 'hint',
          key: 'abc',
        },
        {
          type: 'hint',
          key: ' ',
        },
        {
          key: 'i',
          type: 'blank',
        },
        {
          type: 'hint',
          key: ' ',
        },
        {
          type: 'hint',
          key: 'abc',
        },
        {
          type: 'hint',
          key: ' ',
        },
        {
          type: 'blank',
          key: 'n',
        },
        {
          type: 'blank',
          key: 'i',
        },
        {
          type: 'blank',
          key: 't',
        },
        {
          type: 'blank',
          key: 'a',
        },
        {
          type: 'blank',
          key: 't',
        },
        {
          type: 'blank',
          key: 'i',
        },
        {
          type: 'blank',
          key: 'i',
        },
        {
          type: 'blank',
          key: 'i',
        },
        {
          type: 'hint',
          key: ' ',
        },
        {
          type: 'hint',
          key: 'abc',
        },
        {
          type: 'hint',
          key: ' ',
        },
        {
          type: 'blank',
          key: 'b',
        },
        {
          type: 'blank',
          key: 'u',
        },
        {
          type: 'blank',
          key: 's',
        },
      ],
    },
  ],
  isLyrics: false,
  useColor: false,
} as TextOrderingAnswer;

export const mockHandWritingAnswer: FingerWritingAnswer = {
  soundMode: FingerWritingSoundMode.Silent,
  locale: 'en-US',
  words: [
    {
      word: '我你永',
      characters: [
        {
          character: '我',
          fileId: '我',
        },
        {
          character: '你',
          fileId: '你',
        },
        {
          character: '我',
          fileId: '我',
        },
        {
          character: '你',
          fileId: '你',
        },
        {
          character: '我',
          fileId: '我',
        },
        {
          character: '你',
          fileId: '你',
        },
        {
          character: '永',
          fileId: '永',
        },
        {
          character: '我',
          // fileId: '我',
        },
        {
          character: 'honori',
          // fileId: '我',
        },
        {
          character: '你',
          fileId: '你',
        },
        {
          character: '永',
          fileId: '永',
        },
        {
          character: '我',
          fileId: '我',
        },
        {
          character: '你',
          fileId: '你',
        },
        {
          character: '永',
          // fileId: '永',
        },
        {
          character: '我',
          // fileId: '我',
        },
        {
          character: '你',
          fileId: '你',
        },
        {
          character: '永',
          fileId: '永',
        },
      ],
    },
  ],
} as FingerWritingAnswer;
